import axios from 'axios';

export default {
    data: () => ({
        importer: {
            processing: false,
            processingStartList: false,
            errors: null,
            errorProcessing: false,
            progress: 0,
            updateAthleteClub: false,
            identifyByUSAG: false,
            system: 'Proscore',
            file: null,
            rounds: [
                {
                    value: 'prelims',
                    label: 'Preliminary',
                },
                {
                    value: 'finals',
                    label: 'Finals',
                },
            ],
            meet_id: null,
            round: 'prelims',
        },
    }),

    methods: {
        importResults(event) {
            if (this.importer.system === 'Proscore') {
                return this.importProscore(event);
            }

            if (this.importer.system === 'Virtual') {
                return this.importVirtual();
            }

            return this.importManual();
        },

        async importStartList(event) {
            this.importer.processingStartList = true;

            if (!this.importer.file) {
                [this.importer.file] = event.target.files;
            }

            const form = new FormData();

            await this.resolveMeet(form);

            form.append('file', this.importer.file);
            form.append('round', this.importer.round);

            const self = this;

            try {
                await axios.post('/import-start-list', form);

                window.location.reload();
            } catch (e) {
                if (_.has(e, 'response.data.message')) {
                    this.importer.errors = [e.response.data.message];
                }
                this.importer.errors = _.get(e, 'response.data.errors');
            } finally {
                self.importer.processingStartList = false;
            }
        },

        importManual() {
            const form = this.$inertia.form({
                ...this.newMeet,
                meet_id: this.importer.meet_id,
                round: this.importer.round,
                file: this.importer.file,
            });

            form.post('/import-manual');
        },

        async importVirtual() {
            // TODO: I don't think this is used. Remove?
            // eslint-disable-next-line no-use-before-define
            const redirectMeetId = await this.resolveMeet(form);

            const form = this.$inertia.form({
                virtual: true,
                meet_id: redirectMeetId,
                round: this.importer.round,
                file: this.importer.file,
            });

            form.post('/import-manual');
        },

        async importProscore(event) {
            this.importer.processing = true;

            if (!this.importer.file) {
                [this.importer.file] = event.target.files;
            }

            const form = new FormData();

            const redirectMeetId = await this.resolveMeet(form);

            form.append('update_athlete_club', this.importer.updateAthleteClub);
            form.append('identify_by_usag', this.importer.identifyByUSAG);
            form.append('round', this.importer.round);
            form.append('file', this.importer.file);

            const self = this;

            try {
                const response = await axios.post('/import', form);

                const batchId = response.data.jobId;

                const processingCheck = setInterval(async () => {
                    const { data } = await axios.get(`/batch-status?batch_id=${batchId}`);

                    if (!!data.cancelledAt || data.totalJobs === 0) {
                        self.importer.errorProcessing = true;
                        self.importer.processing = false;
                        clearInterval(processingCheck);
                    }

                    self.importer.progress = data.progress;

                    if (self.importer.progress >= 100) {
                        self.$inertia.visit(`/meets/${redirectMeetId}`);
                        clearInterval(processingCheck);
                    }
                }, 3000);
            } catch (e) {
                this.importer.processing = false;
                this.importer.errors = _.get(e, 'response.data.errors');
            }
        },

        async resolveMeet(form) {
            form.append('meet_id', this.importer.meet_id);

            return this.importer.meet_id;
        },
    },
};
